import { dlog } from "@/config/trackingConfig";

const FIRST = "tn_first_touch";
const LAST = "tn_last_touch";
const CLICK = "tn_click_ids";
const SESSION_LANDING = "tn_session_landing";
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const read = (store, key) => {
  try { return JSON.parse(store.getItem(key) || "null"); } catch { return null; }
};
const write = (store, key, value) => {
  try { store.setItem(key, JSON.stringify(value)); } catch { /* storage blocked */ }
};

export const getCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : "";
};
const setCookie = (name, value, days) => {
  const exp = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax`;
};

const hostOf = (url) => {
  try { return new URL(url).hostname; } catch { return ""; }
};

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  UTM.forEach((k) => { const v = params.get(k); if (v) utm[k] = v.slice(0, 200); });
  const fbclid = params.get("fbclid") || "";
  const gclid = params.get("gclid") || "";
  const referrer = document.referrer || "";
  const externalRef = referrer && hostOf(referrer) !== window.location.hostname ? referrer : "";
  const touch = { ...utm, landing_page_url: window.location.href, referrer: externalRef, ts: new Date().toISOString() };
  const isCampaign = Object.keys(utm).length > 0 || fbclid || gclid;

  if (!read(localStorage, FIRST)) {
    const fallback = isCampaign ? {} : {
      utm_source: externalRef ? hostOf(externalRef) : "(direct)",
      utm_medium: externalRef ? "referral" : "(none)",
    };
    write(localStorage, FIRST, { ...fallback, ...touch });
  }
  if (isCampaign || !read(localStorage, LAST)) write(localStorage, LAST, { ...read(localStorage, FIRST), ...touch });

  if (fbclid || gclid) {
    const prev = read(localStorage, CLICK) || {};
    write(localStorage, CLICK, { ...prev, ...(fbclid && { fbclid }), ...(gclid && { gclid }), ts: touch.ts });
    if (fbclid && !getCookie("_fbc").endsWith(fbclid)) setCookie("_fbc", `fb.1.${Date.now()}.${fbclid}`, 90);
  }
  if (!sessionStorage.getItem(SESSION_LANDING)) {
    write(sessionStorage, SESSION_LANDING, { url: window.location.href, referrer: externalRef });
  }
  dlog("utm", "attribution captured", getAttribution());
}

export function getCurrentUtm() {
  const params = new URLSearchParams(window.location.search);
  const out = {};
  [...UTM, "fbclid", "gclid"].forEach((k) => { if (params.get(k)) out[k] = params.get(k); });
  return out;
}

export function getAttribution() {
  const first = read(localStorage, FIRST) || {};
  const last = read(localStorage, LAST) || {};
  const click = read(localStorage, CLICK) || {};
  const session = read(sessionStorage, SESSION_LANDING) || {};
  const out = {};
  UTM.forEach((k) => {
    const suffix = k.replace("utm_", "");
    if (last[k]) out[k] = last[k];
    if (first[k]) out[`first_touch_${suffix}`] = first[k];
    if (last[k]) out[`last_touch_${suffix}`] = last[k];
  });
  if (click.fbclid) out.fbclid = click.fbclid;
  if (click.gclid) out.gclid = click.gclid;
  out.landing_page_url = session.url || first.landing_page_url || window.location.href;
  out.referrer = session.referrer || first.referrer || "";
  return out;
}

export const getStoredTouches = () => ({
  first: read(localStorage, FIRST),
  last: read(localStorage, LAST),
  clickIds: read(localStorage, CLICK),
});

export const getFbCookies = () => ({ fbp: getCookie("_fbp"), fbc: getCookie("_fbc") });

const META_SOURCES = ["facebook", "fb", "instagram", "ig", "meta"];
// Meta ad visitor = arrived (now or within the stored attribution window) via fbclid or a facebook/instagram utm_source.
export const isMetaAdVisitor = () => {
  const a = getAttribution();
  return !!a.fbclid || META_SOURCES.includes((a.utm_source || "").toLowerCase());
};
